import React from 'react';
import classnames from 'classnames';
import PlayIcon from '../../../../icons/compiled/components/PlayIcon';
import InlineIcon from '../../inline-icon/inline-icon';
import styles from './buttons.scss';
import { CurrencySign } from '../../../../components';
class Buttons extends React.Component {
  getButtonClassNames() {
    const {
      isRTL
    } = this.props;
    const buttonClassNames = classnames(styles.button, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const iconClassNames = classnames(styles.icon, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    const textClassNames = classnames(styles.text, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return {
      buttonClassNames,
      iconClassNames,
      textClassNames
    };
  }
  renderPlayButton() {
    const {
      showPlayButton,
      playButtonText,
      onPlayClick,
      isFocusable
    } = this.props;
    if (!showPlayButton) {
      return null;
    }
    const {
      buttonClassNames,
      iconClassNames,
      textClassNames
    } = this.getButtonClassNames();
    return /*#__PURE__*/React.createElement("button", {
      className: buttonClassNames,
      onClick: onPlayClick,
      tabIndex: isFocusable ? 0 : -1,
      "aria-hidden": !isFocusable,
      "aria-label": playButtonText,
      "data-hook": "overlay-play-button"
    }, /*#__PURE__*/React.createElement(InlineIcon, {
      icon: /*#__PURE__*/React.createElement(PlayIcon, null),
      className: iconClassNames
    }), /*#__PURE__*/React.createElement("div", {
      className: textClassNames
    }, playButtonText), this.renderTooltip(playButtonText));
  }
  renderBuyButton() {
    const {
      showBuyButton,
      buyButtonText,
      onBuyClick,
      isFocusable,
      buyAriaLabel,
      currency
    } = this.props;
    if (!showBuyButton) {
      return null;
    }
    const {
      buttonClassNames,
      iconClassNames,
      textClassNames
    } = this.getButtonClassNames();
    return /*#__PURE__*/React.createElement("button", {
      className: buttonClassNames,
      onClick: onBuyClick,
      tabIndex: isFocusable ? 0 : -1,
      "aria-hidden": !isFocusable,
      "aria-label": buyAriaLabel,
      "data-hook": "paid-access-button"
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.buyIcon, iconClassNames)
    }, /*#__PURE__*/React.createElement(CurrencySign, {
      currency: currency
    })), /*#__PURE__*/React.createElement("div", {
      className: textClassNames
    }, buyButtonText), this.renderTooltip(buyButtonText));
  }
  renderTooltip(text) {
    const {
      isRTL
    } = this.props;
    const classNames = classnames(styles.tooltip, {
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classNames
    }, text);
  }
  render() {
    const {
      showButtonsText,
      className,
      isRTL
    } = this.props;
    const buttonsClassName = classnames(styles.buttons, {
      [styles['without-text']]: !showButtonsText,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    }, className);
    return /*#__PURE__*/React.createElement("div", {
      className: buttonsClassName,
      "data-hook": "thumbnail-buttons"
    }, this.renderPlayButton(), this.renderBuyButton());
  }
}
export default Buttons;
//# sourceMappingURL=buttons.js.map